var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightimg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.65 19.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3dad2b;}.cls-2{fill:#fff;}.cls-3{fill:#006b38;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.77.3a1,1,0,0,0-1.39,0l0,0L6.11,10.54a1,1,0,0,0,0,1.38l0,0,7.67,7.66a1,1,0,0,0,1.39,0l0,0,8.23-8.23.23-5.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.42 4.24 4.88 4.24 4.88 5.82 10.84 5.82 12.42 4.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "20.36 4.24 12.42 4.24 10.84 5.82 20.36 5.82 20.36 4.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 8.31 0 9.89 6.77 9.89 8.35 8.31 0 8.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "15.48 8.31 8.35 8.31 6.77 9.89 15.48 9.89 15.48 8.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.54 12.38 2.23 12.38 2.23 13.96 8.12 13.96 6.54 12.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "17.72 12.38 6.54 12.38 8.12 13.96 17.72 13.96 17.72 12.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.65,6.19l-2,2a1,1,0,0,0,0,1.39l0,0,1.77,1.77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightimg);
export default __webpack_public_path__ + "static/media/rightimg.90187d9da246a068e16ed773b414465c.svg";
export { ForwardRef as ReactComponent };